import AttendStatus from './AttendStatus'

export default AttendStatus;